import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const dataSlice = createSlice({
  name: "update-theme",
  initialState: initialState,
  reducers: {
    initUpdateTheme: () => {
      return { ...initialState };
    },
    startUpdateTheme: (state) => {
      state.loading = true;
    },
    successUpdateTheme: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    errorUpdateTheme: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  initUpdateTheme,
  startUpdateTheme,
  successUpdateTheme,
  errorUpdateTheme,
} = dataSlice.actions;

export default dataSlice.reducer;
